import React from 'react';
import { Box, Typography, Container, Paper, Grid, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: '20px',
    borderRadius: '20px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
}));

const AnimatedDot = styled('span')(({ delay }) => ({
    display: 'inline-block',
    animation: 'bounce 1.4s infinite',
    animationDelay: `${delay}s`,
    '@keyframes bounce': {
        '0%, 80%, 100%': { transform: 'scale(0)' },
        '40%': { transform: 'scale(1.0)' },
    },
}));

const ApprovalProgress = ({ course, sx, ...props }) => {

    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', mt: 2, pt: 2, alignItems: 'center', ...sx }}>
            <Grid container spacing={4} alignItems="center" justifyContent={'center'}>
                <Grid item xs={12} lg={10}>
                    <StyledPaper elevation={0}>
                        <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                            Approval in progress
                            <AnimatedDot delay={0}>.</AnimatedDot>
                            <AnimatedDot delay={0.2}>.</AnimatedDot>
                            <AnimatedDot delay={0.4}>.</AnimatedDot>
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
                            Your course is awaiting teacher approval.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 4 }}>
                            We're excited about your learning journey! The assigned course {course && course.courseName ? (<b>({course?.courseName}) </b>) : ''} is currently under review to ensure it meets your current grade and levels, once approved you would be able to progress ahead.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Est. wait time: 24 hours
                            </Typography>
                        </Box>
                    </StyledPaper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ApprovalProgress;